import { DealActivityState } from "@/enums/dealActivity";

import type { ModalOptions } from "@/models/common";

export const DEFAULT_CMD_K_OPTIONS: ModalOptions = {
  state: DealActivityState.Draggable,
  minimized: false,
  top: -1,
  left: -1,
  width: 650,
  height: 400,
  restoreWidth: 0,
  restoreHeight: 0,
  x: 0,
  y: 0,
} as const;
